
import React, { useState } from 'react';
import { default as API } from '../../../api/';
import IO from '../../../components/io';

const Login = () => {
  const [user_data, set_user_data] = useState({});
  const [server_error, set_server_error] = useState(null);

  const action = async () => {
    await API.tryLogIn(user_data.email, user_data.password).catch(error => {
      let code = error.code;
      let message = error.message;
      if (code === 'auth/wrong-password') {
        set_server_error({
          type: 'password',
          msg: message
        });
        // 'Password seems to be incorrect. We are sorry science has not delivered safe and easy password mgmt yet'
      } else if (code === 'auth/invalid-email') {
        set_server_error({
          type: 'email',
          msg: message
        });
      } else if (code === 'auth/user-not-found') {
        set_server_error({
          type: 'email',
          msg: message
        });
        // "This email and it's user can't not be found on our records. Feel free to create a new account",
      } else {
        set_server_error({
          type: 'unknown',
          msg: message
        });
      }
    });
  };

  const update = vals => set_user_data(vals);

  return (
    
        <IO.Form
        a11yTitle='Log in form'
          report={vals => update(vals)}
          formId={'sign-up'}
          server={server_error}
          tracking={{
            email: '',
            password: ''
          }}>
          <IO.Email name='email' label='Email' autofocus />
          <br />
          <IO.Password name='password' label="password"/>
          <br />
          <IO.Button label={'HELLO AGAIN'} onClick={action} />
        </IO.Form>
  );
};
export default Login